/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Priority_CriticalInputs */

const en_manual_qc_priority_critical = /** @type {(inputs: Manual_Qc_Priority_CriticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Critical`)
};

const fr_manual_qc_priority_critical = /** @type {(inputs: Manual_Qc_Priority_CriticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Critique`)
};

const de_manual_qc_priority_critical = /** @type {(inputs: Manual_Qc_Priority_CriticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kritisch`)
};

const it_manual_qc_priority_critical = /** @type {(inputs: Manual_Qc_Priority_CriticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Critico`)
};

const ru_manual_qc_priority_critical = /** @type {(inputs: Manual_Qc_Priority_CriticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Критический`)
};

const es_manual_qc_priority_critical = /** @type {(inputs: Manual_Qc_Priority_CriticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crítico`)
};

const zh_cn2_manual_qc_priority_critical = /** @type {(inputs: Manual_Qc_Priority_CriticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`批判的`)
};

const ja_manual_qc_priority_critical = /** @type {(inputs: Manual_Qc_Priority_CriticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`致命的`)
};

const hi_manual_qc_priority_critical = /** @type {(inputs: Manual_Qc_Priority_CriticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गंभीर`)
};

const pt_pt2_manual_qc_priority_critical = /** @type {(inputs: Manual_Qc_Priority_CriticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crítico`)
};

/**
* | output |
* | --- |
* | "Critical" |
*
* @param {Manual_Qc_Priority_CriticalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_priority_critical = /** @type {((inputs?: Manual_Qc_Priority_CriticalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Priority_CriticalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_priority_critical(inputs)
	if (locale === "de") return de_manual_qc_priority_critical(inputs)
	if (locale === "it") return it_manual_qc_priority_critical(inputs)
	if (locale === "ru") return ru_manual_qc_priority_critical(inputs)
	if (locale === "es") return es_manual_qc_priority_critical(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_priority_critical(inputs)
	if (locale === "ja") return ja_manual_qc_priority_critical(inputs)
	if (locale === "hi") return hi_manual_qc_priority_critical(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_priority_critical(inputs)
	return en_manual_qc_priority_critical(inputs)
});